$(document).ready(function () {
	if (typeof ImageMapPro !== "undefined") {
		ImageMapPro.subscribe((action) => {
			if (action.type === "mapInit") {
				console.log("mapInit");
				initPlan();
			}
		});
	}
});

function initPlan() {
	$(".plan-map .imp-canvas").responsiveCover({
		container: $(".plan-map"),
		logic: 'cover'
	});
	$(".plan-map .imp-object").each(function () {
		const ref = $(this);
		const slug = ref.data("slug");
		const tooltip = $(`.plan-tooltip-wrapper[data-index="${slug}"]`).html();
		const theme = $(`.plan-tooltip-wrapper[data-index="${slug}"]`).data("theme");
		if (tooltip) {
			tippy(ref[0], {
				content: tooltip,
				allowHTML: true,
				arrow: false,
				placement: "right",
				theme: theme,
				interactive: true,
				trigger: $(window).width() > 1024.98 ? "mouseenter" : "click",
				popperOptions: {
					strategy: "fixed",
				},
				// showOnCreate: true,
				interactiveBorder: 5,
				appendTo: () => document.body,
			});
		}
	});
}
